import React, { useEffect, useState } from "react";
import {
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import api from "../api/api";

export default function FinancialVendorList() {

  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();

  const type =
    searchParams.get("type") || "matched";

  useEffect(() => {
    load();
  }, [type]);

  const load = async () => {

    try {

      setLoading(true);

      const response = await api.get(
        `/vendors/financial-vendors?type=${type}`
      );

      console.log("FINANCIAL ROWS", response);

      setRows(Array.isArray(response) ? response : []);

    } catch (err) {

      console.error(err);
      setRows([]);

    } finally {

      setLoading(false);

    }
  };

  return (
    <div className="p-6">

      {/* Header */}
      <div className="flex items-center justify-between mb-6">

        <div>

          <h1 className="text-2xl font-bold text-sap-text">
            Financial Vendors
          </h1>

          <p className="text-sm text-gray-500">
            Vendor Risk Management / Financial Stability
          </p>

        </div>

        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition"
        >
          ← Back
        </button>

      </div>

      {/* Total Count */}

      <div className="mb-3 text-sm text-gray-500">
        Total Vendors : <b>{rows.length}</b>
      </div>

      {/* Table */}

      <div className="bg-white rounded-lg shadow border overflow-x-auto">

        <table className="w-full">

          <thead>

            <tr className="border-b bg-gray-100">

              <th className="p-3 text-left">
                Vendor
              </th>

              <th className="p-3 text-right">
                Financial Score
              </th>

              <th className="p-3 text-right">
                Invoice Match %
              </th>

              <th className="p-3 text-right">
                Closure %
              </th>

              <th className="p-3 text-center">
                Anomaly
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>
                <td
                  colSpan="5"
                  className="p-4 text-center"
                >
                  Loading...
                </td>
              </tr>

            ) : rows.length === 0 ? (

              <tr>
                <td
                  colSpan="5"
                  className="p-4 text-center"
                >
                  No Records Found
                </td>
              </tr>

            ) : (

              rows.map((row, index) => (

                <tr
                  key={index}
                  className="border-b hover:bg-gray-50"
                >

                  <td className="p-3">
                    {row["Vendor Name"]}
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row.Financial_Score || 0
                    ).toFixed(2)}
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row.Invoice_Match_Percentage || 0
                    ).toFixed(2)}
                    %
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row.Invoice_Closure_Percentage || 0
                    ).toFixed(2)}
                    %
                  </td>

                  <td className="p-3 text-center">
                    {row.Anomaly}
                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}